/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import CommonVars from "../components/CommonVars";
import {
    Heading,
    Box,
    Text,
    Stack,
    Flex,
    Button,
    HStack,
    Select, 
    FormControl, 
    FormLabel,
    Input,
    NumberInput, 
    NumberInputField, 
    NumberInputStepper, 
    NumberIncrementStepper, 
    NumberDecrementStepper,
    useToast
} from "@chakra-ui/react";
import { Form, Formik } from 'formik';
import CustomFormInput from "../components/FormInputFields";
import * as Yup from 'yup';
import axios from 'axios';
import { useParams } from "react-router-dom";

function UpdateProducts () {
    // access token from local storage
    const theToken = localStorage.getItem('token');
    const [productDetails, setProductsDetails] = useState('');
    const [categories, setCategories] = useState([]);

    const productid = useParams().productid;

    // get products by Id from server
    const getProductById = async () => {
        axios.get(`${CommonVars.API_URL}/products/${productid}`)
        .then((res) => {
            setProductsDetails(res.data);
        })
        .catch((err) => {
            console.log(err);   
        });
    };

    // access backend to retrieve all categories
    const getCategories = async () => {
        axios.get(`${CommonVars.API_URL}/category`)
        .then((res) => {
            // console.log(res.data);
            setCategories(res.data);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getProductById()
        getCategories();
    }, []);

    // set update product toast message
    const udPdtToast = useToast();
    const id = 'udPdt-toast';

    const category = [];

    for (let i = 0; i < categories.length; i++) {
        category.push(
            <option key={categories[i].categoryid} value={categories[i].categoryid}>{categories[i].categoryname}</option>
        )
    }

    return (
        <Formik
            initialValues={{
                name: '',
                desc: '',
            }}
            validationSchema={Yup.object({
                name: Yup.string()
                .min(4, 'Product name must be at least 4 characters'),
                desc: Yup.string()
                .min(4, 'Product description must be at least 4 characters'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                let pdtName = String(values.name);
                let pdtDesc = String(values.desc);
                const catSelected = document.getElementById('dropDownCats');
                const catID = parseInt(catSelected.value, 10);
                const inUpPrice = document.getElementById('upPrice');
                let upPdtPrice = parseInt(inUpPrice.value);
                // form data for image uploading
                const formData = new FormData();
                let upPdtfile = document.getElementById('upPdtImg').files[0];
                formData.append('image', upPdtfile);
                if (pdtName == '') {
                    pdtName = productDetails.name;
                }
                if (pdtDesc == '') {
                    pdtDesc = productDetails.description;
                }
                if (isNaN(upPdtPrice)) {
                    upPdtPrice = parseInt(productDetails.price);
                }
                if (upPdtfile == undefined) {
                    upPdtfile = productDetails.products_img_url
                }
                // no new image selected
                if (typeof upPdtfile == 'string') {
                    const updateProductRequestBody = {
                        name: pdtName,
                        price: upPdtPrice,
                        desc: pdtDesc,
                        p_img_url: upPdtfile,
                        categoryid: catID
                    }
                    // access backend to update product
                    axios.put(`${CommonVars.API_URL}/products/${productid}`, updateProductRequestBody, {
                        headers: { Authorization: `Bearer ${theToken}` },
                    })
                    .then(() => {
                        setSubmitting(false);
                        if(!udPdtToast.isActive(id)) {
                            udPdtToast({
                                id,
                                title: 'Product Updated!',
                                description: "The product is updated successfully!",
                                status: 'success',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        resetForm();
                        setTimeout(() => {
                            window.location.replace(`/products`);
                        }, 1500);
                    })
                    .catch((error) => {
                        if(!udPdtToast.isActive(id)) {
                            udPdtToast({
                                id,
                                title: 'Product Updating Failed.',
                                description: "Something went wrong with updating...",
                                status: 'error',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        console.log(error);
                    });
                } else if (typeof upPdtfile == 'object') {
                    // upload the new image to cloudinary first
                    axios.post(`${CommonVars.API_URL}/upload-pdtImg`,
                        formData,
                        { headers: { Authorization: `Bearer ${theToken}` } },
                    )
                    .then((res) => {
                        const newPdtImage = res.data;
                        // prepare the request body
                        const updateProductRequestBody2 = {
                            name: pdtName,
                            price: upPdtPrice,
                            desc: pdtDesc,
                            p_img_url: newPdtImage,
                            categoryid: catID
                        }
                        // access backend to update product
                        axios.put(`${CommonVars.API_URL}/products/${productid}`, updateProductRequestBody2, {
                            headers: { Authorization: `Bearer ${theToken}` },
                        })
                        .then(() => {
                            setSubmitting(false);
                            if(!udPdtToast.isActive(id)) {
                                udPdtToast({
                                    id,
                                    title: 'Product Updated!',
                                    description: "The product is updated successfully!",
                                    status: 'success',
                                    position: 'top',
                                    duration: 2000,
                                    isClosable: true,
                                });
                            }
                            resetForm();
                            setTimeout(() => {
                                window.location.replace(`/products`);
                            }, 1500);
                        })
                        .catch((error) => {
                            if(!udPdtToast.isActive(id)) {
                                udPdtToast({
                                    id,
                                    title: 'Product Updating Failed.',
                                    description: "Something went wrong with updating...",
                                    status: 'error',
                                    position: 'top',
                                    duration: 2000,
                                    isClosable: true,
                                });
                            }
                            console.log(error);
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                }
            }}
        >
            {props => (
                <Flex 
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                        <Stack align={'center'}>
                                <Heading fontSize={'4xl'}>Update an existing product</Heading>
                                <Text fontSize={'lg'} color={'gray.600'}>
                                    Update the necessary product details to keep up to date.
                                </Text>
                        </Stack>
                        <Box
                            rounded={'lg'}
                            bg={'white'}
                            boxShadow={'lg'}
                            p={8}
                        >
                            <Form>
                                <Stack spacing={5}>
                                    {/* Product Name */}
                                    <CustomFormInput
                                        label="Product Name"
                                        name="name"
                                        type="text"
                                        placeholder={`${productDetails.name}`}
                                    />
                                    {/* Product Description */}
                                    <CustomFormInput
                                        label="Description" 
                                        name="desc" 
                                        type="text"
                                        placeholder={`${productDetails.description}`}
                                    />
                                    {/* Product Price */}
                                    <FormControl>
                                        <FormLabel>Product Price</FormLabel>
                                        <NumberInput size='sm' maxW={90} min={10}>
                                            <NumberInputField id="upPrice" placeholder={`${productDetails.price}`}/>
                                            <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                            </NumberInputStepper>
                                        </NumberInput>
                                    </FormControl>
                                    {/* Product Image Input */}
                                    <FormControl>
                                        <FormLabel>Product Image</FormLabel>
                                        <Input id="upPdtImg" placeholder='medium size' size='md' type={'file'} variant={'flushed'} />
                                    </FormControl>
                                    {/* Category Options */}
                                    <FormControl>
                                        <FormLabel>Select Category</FormLabel>
                                            <Select id="dropDownCats">
                                                {category}
                                            </Select>
                                    </FormControl>
                                    <HStack spacing='20px' pt={2} pb={1}>
                                        <Button type='submit' bg={'black'} color={'white'} _hover={{bg: '#37404A',}}>{props.isSubmitting ? 'Loading...' : 'Update Product'}</Button>
                                        <Button type='reset'>Reset</Button>
                                    </HStack>
                                </Stack>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            )}
        </Formik>
    )
}

export default UpdateProducts;